import React from 'react';
import classNames from 'classnames';

import ComparisonBaseCell from '@/views/containers/comparison/ComparisonTable/ComparisonBaseCell';
import { FormattedMessageV2 } from '@/views/components/i18n';

import { TaxImplicationResult } from '@capintel/instruments-lib';

const getRowClass = (meta?: RowMeta) =>
  classNames('tax-analysis-table-row', {
    'tax-analysis-table-row-tall': meta?.isTall,
    'tax-analysis-loss-row': meta?.isLossRow,
    'tax-analysis-section-divider': meta?.hasSectionDivider,
  });

const getLabelClass = (meta?: RowMeta) =>
  classNames('tax-analysis-table-label', {
    'tax-analysis-sub-row': meta?.isSubRow,
  });

export type RowMeta = {
  isSubRow?: boolean;
  isLossRow?: boolean;
  hasSectionDivider?: boolean;
  isTall?: boolean;
};

type Row = {
  key: string;
  label: React.ReactNode;
  cell?: (props: { taxAnalysisData: TaxImplicationResult }) => React.ReactNode;
  meta?: RowMeta;
};

type ImplicationsSectionProps = {
  captionKey?: string;
  sectionKey: string;
  rows: Row[];
  taxAnalysisData: TaxImplicationResult;
};

const ImplicationsSection: React.FC<ImplicationsSectionProps> = ({ captionKey, sectionKey, rows, taxAnalysisData }) => (
  <table className="tax-analysis-implications-table">
    {captionKey && (
      <caption className="tax-analysis-table-caption">
        <FormattedMessageV2 toLocalize={captionKey} />
      </caption>
    )}

    <tbody>
      {rows.map((row, index) => (
        <tr key={row.key} className={getRowClass(row.meta)}>
          <td className={getLabelClass(row.meta)}>
            <ComparisonBaseCell>{row.label}</ComparisonBaseCell>
          </td>
          <td className="tax-analysis-table-value">
            <ComparisonBaseCell>{row.cell?.({ taxAnalysisData }) ?? ''}</ComparisonBaseCell>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default ImplicationsSection;
